module.exports = __webpack_public_path__ + "img/kechen.d6fc0b2f.png";